import { useState, useEffect, useRef, useMemo } from "react";
import * as THREE from "three";
import { useFrame, useThree } from "@react-three/fiber";
import { useTimer } from "use-timer";
import SceneThree from "./Background-scene/SceneThree";
import gsap from "gsap";
import { getRenderer } from "./WebGLRendererSingleton";

const LevelFour = ({
  data,
  // worldPosition,
  setConfetti,
  // setChangeBackground,
  Yay,
  halfY,
  nextClick,
  setNextClick,
  wordCount,
}) => {
  const ref = useRef();
  const { time, start, pause, reset, status } = useTimer();
  const [spriteScale, setSpriteScale] = useState([0, 0, 0]);
  const [clickCurrect, setClickCurrent] = useState(undefined);
  const [intersectedObj, setIntersectedObj] = useState([]);
  const [click, setClick] = useState("");

  const [worldPosition, setWorldPosition] = useState();
  const [changeBackground, setChangeBackground] = useState("");
  const [enableClick, setEnableClick] = useState(false);

  const { gl, scene } = useThree();
  const width = window.innerWidth;
  const height = window.innerHeight;
  const aspect = width / height;
  var timeOut;
  const fov = 50;
  const planeAspectRatio = 16 / 9;

  const viewSize = 50;
  var camera = new THREE.OrthographicCamera();
  camera.aspect = width / height;

  const loader = new THREE.TextureLoader();
  // A png with transparency to use as the target sprite.
  const dt = data;
  const textureA = useMemo(
    () => loader.load(dt[0]?.letterImg),
    [dt[0]?.letterImg]
  );

  // const textureA = loader.load(dt[0]?.letterImg);
  textureA.name = dt[0]?.mainLetter;
  textureA.colorSpace = THREE.SRGBColorSpace;
  textureA.minFilter = THREE.LinearFilter;

  const textureB = useMemo(
    () => loader.load(dt[1]?.letterImg),
    [dt[1]?.letterImg]
  );
  // const textureB = loader.load(dt[1]?.letterImg);
  textureB.name = dt[1]?.mainLetter;
  textureB.colorSpace = THREE.SRGBColorSpace;
  textureB.minFilter = THREE.LinearFilter;

  const textureC = useMemo(
    () => loader.load(dt[2]?.letterImg),
    [dt[2]?.letterImg]
  );

  // const textureC = loader.load(dt[2]?.letterImg);
  textureC.name = dt[2]?.mainLetter;
  textureC.colorSpace = THREE.SRGBColorSpace;
  textureC.minFilter = THREE.LinearFilter;

  const objectTexture = useMemo(
    () => loader.load(dt[0]?.objectImg ? dt[0]?.objectImg : dt[0]?.letterImg),
    [dt[0]?.objectImg]
  );
  objectTexture.colorSpace = THREE.SRGBColorSpace;
  objectTexture.minFilter = THREE.LinearFilter;

  const nameTexture = useMemo(
    () => loader.load(dt[0]?.nameImg ? dt[0]?.nameImg : dt[0]?.letterImg),
    [dt[0]?.nameImg]
  );
  nameTexture.colorSpace = THREE.SRGBColorSpace;
  nameTexture.minFilter = THREE.LinearFilter;

  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  const [effectActive, setEffectActive] = useState(undefined);

  const [renderers, setrenderers] = useState([]);
  const [doubleVoiceConflict, setDoubleVoiceConflict] = useState(false)
  var listener = new THREE.AudioListener();
  camera.add(listener);
  // create a global audio source
  var sound = new THREE.Audio(listener);

  var audioLoader = new THREE.AudioLoader();

  function createRenderer() {
    if (renderers.length === 0) {
      const rendererr = getRenderer();

      setrenderers((prev) => [...prev, rendererr]);
      return rendererr;
    }
  }

  let renderer;
  if (renderers.length === 0) {
    renderer = createRenderer();
  }

  renderer?.domElement?.addEventListener("webglcontextlost", (event) => {
    console.log("WebGL context lost", gl.info.memory);
    textureA.dispose();
    textureB.dispose();
    textureC.dispose();
    objectTexture.dispose();
    nameTexture.dispose();
    clearTexture();
    setTimeout(() => {
      renderer?.forceContextRestore();
    }, 1000);
    // Handle context lost situation here
  });

  // Listen for context restored event
  renderer?.domElement?.addEventListener("webglcontextrestored", (event) => {
    console.log(" WebGL context restored");
    // Resources should be reloaded or recreated here
  });

  function useAspect(width, height, factor = 0.12) {
    const { viewport: v } = useThree();
    const adaptedHeight =
      height * (aspect > width / height ? v.width / width : v.height / height);
    const adaptedWidth =
      width * (aspect > width / height ? v.width / width : v.height / height);
    return [adaptedWidth * factor, adaptedHeight * factor, 1];
  }

  const [aspectWidth, aspectHeight] = useAspect(
    window.innerWidth,
    window.innerHeight
  );

  useFrame(({ clock }) => {
    if (effectActive && status === "RUNNING") {
      const elapsedTime = clock.getElapsedTime();
      // Sine wave for continuous squash and stretch effect
      const scaleFactor = Math.sin(elapsedTime * 2) * 0.5 + 1.7;
      const stretchFactor = 1 / scaleFactor;
      const actualAlphabet = ref.current.children.filter(({ name }) =>
        data.some(
          (x) => x.mainLetter == name && name !== undefined && name !== ""
        )
      );
      // Apply squash and stretch by scaling on different axes
      //ref.current.children[0]?.scale.set(stretchFactor, scaleFactor, stretchFactor);
      actualAlphabet[0].scale.x = stretchFactor;
      actualAlphabet[0].scale.y = stretchFactor;
    } else if (!effectActive && status === "RUNNING") {
      const actualAlphabet = ref.current.children.filter(({ name }) =>
        data.some(
          (x) => x.mainLetter == name && name !== undefined && name !== ""
        )
      );
      actualAlphabet[0].scale.set(aspectWidth, aspectWidth, 1);
    }
  });

  useEffect(() => {
    // adjustSpriteSize();

    // window.addEventListener("resize", function (e) {
    //   adjustSpriteSize();

    //   const height = window.innerHeight;
    //   const aspect = width / height;
    //   camera.aspect = window.innerWidth / window.innerHeight;

    //   if (camera.aspect > planeAspectRatio) {
    //     // window too large
    //     const cameraHeight = Math.tan(MathUtils.degToRad(fov / 2));
    //     const ratio = camera.aspect / planeAspectRatio;
    //     const newCameraHeight = cameraHeight / ratio;
    //     camera.fov = MathUtils.radToDeg(Math.atan(newCameraHeight)) * 2;
    //   } else {
    //     // window too narrow
    //     camera.fov = fov;
    //   }
    //   camera.updateProjectionMatrix();
    //   visibleWidthAtZDepth(camera.fov, camera);

    //   renderer?.setSize(width, height);
    // });
    return () => {
      // ref.current = null
      objectTexture.dispose();
      nameTexture.dispose();
      textureA.dispose();
      textureB.dispose();
      textureC.dispose();
      scene.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.geometry.dispose();
          // child.material.dispose()
        }
        if (child instanceof THREE.Sprite) {
          child.geometry.dispose();
          // child.material.dispose();
        }
      });

      if (renderer) {
        renderer?.dispose();
      }
    };
  }, []);

  useEffect(() => {
    setChangeBackground("ovals");
  }, [data]);

  useEffect(() => {
    if (sound.isPlaying) {
      sound.stop()
      sound.pause()
    }
    setClickCurrent(undefined);
    setConfetti({ run: false, ratio: 0 });
    setIntersectedObj([]);
    setEffectActive(undefined);
    setDoubleVoiceConflict(false)
    pause();
    ref.current.children[0].visible = false;
    ref.current.children[1].visible = false;
    ref.current.children[2].visible = false;

    setClick("");

    timeOut = setTimeout(() => {
      if (ref.current) {
        ref.current.children[0].position.y = 4;
        ref.current.children[1].position.y = 4;
        ref.current.children[2].position.y = 4;
        if (dt?.length > 0 && worldPosition && ref.current) {
          ref.current.children[0]?.scale.set(aspectWidth, aspectWidth, 1);
          ref.current.children[1]?.scale.set(aspectWidth, aspectWidth, 1);
          ref.current.children[2]?.scale.set(aspectWidth, aspectWidth, 1);
          arrangeObj();
        }
      }
    }, 2000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [dt, worldPosition]);

  useEffect(() => {


    const timer = setTimeout(() => {
      console.log("see", clickCurrect, enableClick)
      checkNone()


    }, 8000);

    return () => clearTimeout(timer);
  }, [clickCurrect]);



  function checkNone() {
    // Perform actions after waiting for 3 seconds
    if (data?.length > 0 && ref.current.children?.length > 0) {
      console.log(9999, clickCurrect, enableClick)
      // if (clickCurrect === undefined && !enableClick) {
      setEffectActive(true);
      start();
      if (sound.isPlaying) {
        sound.pause()
        sound.stop()
      }
      setTimeout(() => {
        noneTwo()

      }, 3000);
      // }
    }
  }
  useEffect(() => {

  }, [])

  function noneTwo() {
    // setTimeout(() => {
    console.log('NEW STATE', doubleVoiceConflict)
    if (clickCurrect === undefined && !enableClick) {
      if (sound.isPlaying) {
        sound.pause()
        sound.stop()
      }
      console.log(999999, 'here', clickCurrect, enableClick)
      setEffectActive(false);
      pause();
      setClickCurrent(false);
      setClick("none");
    }
    // }, 3000);

  }

  useEffect(() => {
  }, [click, effectActive])

  useEffect(() => {
    if (ref.current.children?.length > 0 && worldPosition && data?.length > 0) {
      if ((effectActive === undefined || !effectActive) && click === "first") {
        if (sound.isPlaying) {
          sound.pause()
          sound.stop()
        }
        pause();
        setEffectActive(false);
        setEnableClick(false);
        console.log('11111111111')
        const actualAlphabet = ref.current.children.filter(({ name }) =>
          data.some(
            (x) => x.mainLetter == name && name !== undefined && name !== ""
          )
        );

        timeOut = setTimeout(() => {
          const actualAlphabet = ref.current.children.filter(({ name }) =>
            data.some(
              (x) => x.mainLetter == name && name !== undefined && name !== ""
            )
          );
          const index = ref.current.children.indexOf(actualAlphabet[0]);
          const removeAlphabet = ref.current.children.filter(({ name }) =>
            data.some((x) => name === undefined || name === "")
          );
          setEnableClick(false)
          setChangeBackground("hide-2-oval");
          removeAlphabet?.map((itm, index2) => {
            const j = ref.current.children.indexOf(itm);
            ref.current.children[j].visible = false;
          });

          gsap.to(ref.current.children[index]?.position, {
            x: worldPosition.middle.x, //+ aspectWidth / 1.5,
            y: worldPosition.middle.y - aspectWidth / 4,
          });
          gsap.to(ref.current.children[index]?.scale, {
            x: aspectWidth,
            y: aspectWidth,
          });

          setTimeout(() => {
            pause();

            audioPlay(Yay);
            setConfetti({ run: true, ratio: 1 });
            setTimeout(() => {
              audioPlay(data[index].wordMusic);
              setTimeout(() => {
                if (nextClick < 2) {
                  if (renderer) {
                    renderer?.dispose();
                  }

                  setNextClick(nextClick + 1);
                  objectTexture.dispose();
                  nameTexture.dispose();
                  textureA.dispose();
                  textureB.dispose();
                  textureC.dispose();
                  clearTexture();
                  setChangeBackground("");
                } else if (nextClick === 2) {
                  if (renderer) {
                    renderer?.dispose();
                  }

                  objectTexture.dispose();
                  nameTexture.dispose();
                  textureA.dispose();
                  textureB.dispose();
                  textureC.dispose();
                  clearTexture();
                  setChangeBackground("");
                }
              }, 4000);
            }, 2000);
          }, 2000);
        }, 2000);
      } else if (!effectActive && click === "second") {
        // setChangeBackground("square");
        //if (sound.isPlaying) {
        sound.pause()
        sound.stop()
        // }
        setDoubleVoiceConflict(!doubleVoiceConflict)
        setEnableClick(false);
        console.log('2222222');

        const actualAlphabet = ref.current.children?.filter(({ name }) =>
          data.some(
            (x) => x.mainLetter == name && name !== undefined && name !== ""
          )
        );
        const index = ref.current.children?.indexOf(actualAlphabet[0]);

        const removeAlphabet = ref.current.children?.filter(({ name }) =>
          data.some((x) => name === undefined || name === "")
        );
        setEnableClick(false)
        setChangeBackground("hide-2-oval");
        removeAlphabet?.map((itm, index2) => {
          const j = ref.current.children?.indexOf(itm);
          ref.current.children[j].visible = false;
        });

        gsap.to(ref.current.children[index]?.position, {
          x: worldPosition.middle.x, // + aspectWidth / 1.5,
          y: worldPosition.middle.y - aspectWidth / 4,
        });
        gsap.to(ref.current.children[index]?.scale, {
          x: aspectWidth,
          y: aspectWidth,
        });

        ref.current.children[0]?.scale.set(aspectWidth, aspectWidth, 1);
        // setEffectActive(false);

        timeOut = setTimeout(() => {
          audioPlay(halfY);

          setConfetti({ run: true, ratio: 0.3 });
          setTimeout(() => {
            console.log('2222 audio')
            audioPlay(data[index].wordMusic);
            setTimeout(() => {
              if (nextClick < 2) {
                if (renderer) {
                  renderer?.dispose();
                }

                objectTexture.dispose();
                nameTexture.dispose();
                textureA.dispose();
                textureB.dispose();
                textureC.dispose();
                setNextClick(nextClick + 1);
                clearTexture();
                setChangeBackground("");
              } else if (nextClick === 2) {
                if (renderer) {
                  renderer?.dispose();
                }

                objectTexture.dispose();
                nameTexture.dispose();
                textureA.dispose();
                textureB.dispose();
                textureC.dispose();
                clearTexture();
                setChangeBackground("");
              }
            }, 4000);
          }, 2000);
        }, 2000);
      } else if (
        !effectActive &&
        effectActive !== undefined &&
        click === "none" &&
        doubleVoiceConflict === false
      ) {
        setEnableClick(false);
        console.log('33333333', doubleVoiceConflict)
        //if (sound.isPlaying) {
        sound.pause()
        sound.stop()
        //}

        // setChangeBackground("square");
        const actualAlphabet = ref.current.children?.filter(({ name }) =>
          data.some(
            (x) => x.mainLetter == name && name !== undefined && name !== ""
          )
        );
        const index = ref.current.children?.indexOf(actualAlphabet[0]);

        const removeAlphabet = ref.current.children?.filter(({ name }) =>
          data.some((x) => name === undefined || name === "")
        );

        timeOut = setTimeout(() => {
          setEnableClick(false)
          setChangeBackground("hide-2-oval");
          removeAlphabet?.map((itm, index2) => {
            const j = ref.current.children?.indexOf(itm);
            ref.current.children[j].visible = false;
          });

          gsap.to(ref.current.children[index]?.position, {
            x: worldPosition.middle.x, // + aspectWidth / 1.5,
            y: worldPosition.middle.y - aspectWidth / 4,
          });
          gsap.to(ref.current.children[index]?.scale, {
            x: aspectWidth,
            y: aspectWidth,
          });

          // setEffectActive(false);

          ref.current.children[0]?.scale.set(aspectWidth, aspectWidth, 1);

          setTimeout(() => {
            console.log('3333 audio')
            audioPlay(data[index].wordMusic);
            setTimeout(() => {
              if (nextClick < 2) {
                if (renderer) {
                  renderer?.dispose();
                }

                objectTexture.dispose();
                nameTexture.dispose();
                textureA.dispose();
                textureB.dispose();
                textureC.dispose();
                setNextClick(nextClick + 1);
                clearTexture();
                setChangeBackground("");
              } else if (nextClick === 2) {
                if (renderer) {
                  renderer?.dispose();
                }

                clearTexture();
                objectTexture.dispose();
                nameTexture.dispose();
                textureA.dispose();
                textureB.dispose();
                textureC.dispose();
                setChangeBackground("");
              }
            }, 4000);
          }, 2000);
        }, 2000);
      }
    }
  }, [click, effectActive]);

  function onMouseClick(event, name) {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }
    console.log('mouse click', enableClick)
    if (enableClick) {

      // Calculate mouse position in normalized device coordinates (-1 to +1)
      mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
      mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
      // Update the picking ray with the camera and mouse position
      raycaster.setFromCamera(mouse, camera);

      // // Calculate objects intersecting the picking ray
      // working
      var vector = new THREE.Vector3(
        (event.clientX / window.innerWidth) * 2 - 1,
        -(event.clientY / window.innerHeight) * 2 + 1,
        0.5
      );
      var raycasterr = new THREE.Raycaster(
        camera?.position,
        vector.sub(camera?.position).normalize()
      );
      raycasterr.setFromCamera(vector, camera);

      // var intersectss = raycasterr.intersectObjects(intersectedObj, false);

      // alternative
      var intersectss = intersectedObj?.filter(
        (itm) => itm.name === name && itm.name !== "" && itm.name !== undefined
      );

      for (let i = 0; i < intersectss.length; i++) {
        const intersectedObject = intersectss[0];

        if (effectActive) {

          setClick("second");
        } else if (effectActive === undefined) {
          setClick("first");
        }

        // clickCurrect = true

        // setTimeout(() => {
        pause();
        setEffectActive(false);
        setClickCurrent(true);
        setTimeout(() => {
          document.body.style.cursor = "pointer";
          // Perform any actions with the intersected object
          pause();
        }, 1000);
      }
    }
  }

  function adjustSpriteSize() {
    // Get the screen dimensions
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Define a base size for the sprite
    const baseWidth = 550; // Adjust this value as needed
    const baseHeight = 550; // Adjust this value as needed

    // Calculate the scale factors
    const scaleX = screenWidth / baseWidth;
    const scaleY = screenHeight / baseHeight;

    setSpriteScale([scaleX, scaleY, 0]);
  }



  function audioPlay(name) {
    if (sound.isPlaying) {
      sound.stop();
      sound.pause();
    }

    //Load a sound and set it as the Audio object's buffer
    audioLoader.load(`${name}`, function (buffer) {
      sound.setBuffer(buffer);

      sound.stop();
      sound.setLoop(false);
      sound.setVolume(1);
      sound.play();
    });
  }

  const visibleHeightAtZDepth = (depth, camera) => {
    // compensate for cameras not positioned at z=0
    const cameraOffset = camera?.position.z;
    if (depth < cameraOffset) depth -= cameraOffset;
    else depth += cameraOffset;

    // vertical fov in radians
    const vFOV = (camera.fov * Math.PI) / 180;

    // Math.abs to ensure the result is always positive
    return 2 * Math.tan(vFOV / 2) * Math.abs(depth);
  };

  const visibleWidthAtZDepth = (depth, camera) => {
    const height = visibleHeightAtZDepth(depth, camera);

    return height * camera.aspect;
  };

  function arrangeObj() {
    if (ref.current.children?.length > 3) {
      ref.current.remove(ref.current.children[3]);

      ref.current.remove(ref.current.children[3]);
    }

    ref.current.children[0].visible = true;
    ref.current.children[1].visible = true;
    ref.current.children[2].visible = true;

    const positionLeft = worldPosition.left; // new THREE.Vector3({x: 1,y:0, z:0});
    const positionMiddle = worldPosition.middle;
    // ref.current.children[3].getWorldPosition(position);
    const positionRight = worldPosition.right; // new THREE.Vector3({x: -1, y:0, z:0});

    // gsap.to(clickHand.position, {
    //   x: positionLeft?.x - aspect,
    //   y: -1,
    // });
    // letter

    gsap.fromTo(
      ref.current.children[0]?.position,
      {
        y: 4, // 4,
        x: positionLeft.x + aspectWidth / 2.2, // + 0.8,
        z: 1,
      },
      {
        y: positionLeft.y,
        duration: 2,
        onComplete: () => {
          if (
            ref.current.children[0]?.name !== "" &&
            ref.current.children[0]?.name !== undefined
          ) {
            audioPlay(dt[0].music);
          }
        },
      }
    );

    gsap.fromTo(
      ref.current.children[1]?.position,
      {
        y: 4, // 4,
        x: positionMiddle.x,
        z: 1,
      },
      {
        y: positionMiddle.y - aspectWidth / 4.6,
        duration: 2,
        onComplete: () => {
          if (
            ref.current.children[1]?.name !== "" &&
            ref.current.children[1]?.name !== undefined
          ) {
            audioPlay(dt[1].music);
          }
        },
      }
    );
    gsap.fromTo(
      ref.current.children[2]?.position,
      {
        y: 4, // 4,
        x: positionRight.x - ref.current.children[2].scale.x / 2.2,
        z: 1,
      },
      {
        y: positionRight.y,
        duration: 2,
        onComplete: () => {
          if (
            ref.current.children[2]?.name !== "" &&
            ref.current.children[2]?.name !== undefined
          ) {
            audioPlay(dt[2].music);
          }
        },
      }
    );
    setEnableClick(true);
    setIntersectedObj(ref.current.children);

    // setIntersectedObj([ref.current.children[0], ref.current.children[1], ref.current.children[2]])
  }

  // const clearTexture = () => {
  //   scene.traverse(function (child) {
  //     if (child instanceof THREE.Mesh) {
  //       child.geometry.dispose();
  //       // child.material.dispose();
  //     }
  //     if (child instanceof THREE.Sprite) {
  //       child.geometry.dispose();
  //       // child.material.dispose();
  //     }
  //     if (child instanceof THREE.Group) {
  //       child.traverse(function (nestedChild) {
  //         // if (nestedChild instanceof THREE.Mesh) {
  //         //   nestedChild.geometry.dispose();
  //         //   nestedChild.material.dispose();
  //         // }
  //         // if (nestedChild instanceof THREE.Sprite) {
  //         //   nestedChild.geometry.dispose();
  //         //   nestedChild.material.dispose();
  //         // }
  //       });
  //     }
  //   });
  //   renderer?.dispose();
  // };

  const clearTexture = () => {
    scene.traverse(function (child) {
      if (child instanceof THREE.Mesh) {
        child.geometry.dispose();
        if (child.material.isMaterial) {
          child.material.dispose();
        }
      }
      if (child instanceof THREE.Sprite) {
        // console.log(child)
        const disposeMaterial = (material) => {
          Object.getOwnPropertyNames(material).forEach((property) => {
            if (property === "isMaterial") {
              const materialProperty = material[property];

              if (materialProperty !== undefined) {
                var texture = material.map;
                var image = texture.source.data;

                if (image instanceof Image) {
                  image = null;
                } else {
                  texture.image = null;
                }
                texture.dispose();
              }
            }
          });
          material.dispose();
        };
        disposeMaterial(child.material);

        child.geometry.dispose();
        // if (Array.isArray(child.material)) {
        //   child.material.dispose();
        // }
      }
      if (child instanceof THREE.Group) {
        child.traverse(function (nestedChild) {
          // if (nestedChild instanceof THREE.Mesh) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // }
          // if (nestedChild instanceof THREE.Sprite) {
          //   nestedChild.geometry.dispose();
          //   nestedChild.material.dispose();
          // }
        });
      }
    });
  };

  return (
    <>
      <SceneThree
        level={4}
        changeBackground={changeBackground}
        setWorldPosition={setWorldPosition}
      />
      <group ref={ref} dispose={null}>
        <mesh
          name={dt[0]?.mainLetter !== "" ? dt[0]?.mainLetter : ""}
          scale={[aspectWidth, aspectWidth, 1]}
          onClick={(e) => {
            onMouseClick(e, dt[0]?.mainLetter);
          }}
        >
          <sprite isSprite={true}>
            <spriteMaterial
              attach="material"
              map={textureA}
              precision={"lowp"}
            />
          </sprite>
        </mesh>

        <mesh
          name={dt[1]?.mainLetter !== "" ? dt[1]?.mainLetter : ""}
          scale={[aspectWidth, aspectWidth, 1]}
          onClick={(e) => {
            onMouseClick(e, dt[1]?.mainLetter);
          }}
        >
          <sprite isSprite={true}>
            <spriteMaterial
              attach="material"
              map={textureB}
              precision={"lowp"}
            />
          </sprite>
        </mesh>

        <mesh
          name={dt[2]?.mainLetter !== "" ? dt[2]?.mainLetter : ""}
          scale={[aspectWidth, aspectWidth, 1]}
          onClick={(e) => {
            onMouseClick(e, dt[2]?.mainLetter);
          }}
        >
          <sprite isSprite={true}>
            <spriteMaterial
              attach="material"
              map={textureC}
              precision={"lowp"}
            />
          </sprite>
        </mesh>
        {/* <mesh
          scale={[
            spriteScale[0] / 1.6,
            spriteScale[1] / 1.4,
            spriteScale[2] / 1.6,
          ]}
          visible={false}
        >
          <sprite>
            <spriteMaterial
              attach="material"
              map={clickHand}
             
            />
          </sprite>
        </mesh> */}
      </group>
    </>
  );
};

export default LevelFour;
